import { useServiceError } from '@/hooks';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import { DEFAULT_ROWS, DEFAULT_ORDER } from '..';
import {
  materialReturnList,
  returnMaterial,
  returnMaterialDetail,
} from './MaterialReturn.service';
import { MaterialReturnListRequest } from './MaterialReturn.types';
import { materialReturnDicionaryError } from './MaterialReturn.errors';

export function useMaterialReturnList(params?: MaterialReturnListRequest) {
  return useInfiniteQuery(
    [['materials-return'], params],
    ({ pageParam }) =>
      materialReturnList({
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      }),
    {
      getNextPageParam: (lastPage) => lastPage.result.nextToken,
      enabled: !!params?.companyId && !!params.type,
      onError(error) {
        notificationError(error, {
          message: 'Listagem de materiais entregues',
          description: 'Não foi possível listar os materiais.',
        });
      },
    },
  );
}

export function useReturnMaterial() {
  const mutation = useMutation(returnMaterial, {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'Devolução realizada com sucesso!',
      });
    },

    onError(error) {
      notificationError(error, {
        translate: (errors) =>
          errors.map((err) => materialReturnDicionaryError[err] || err),
      });
    },
  });

  return mutation;
}

export function useReturnMaterialDetail(id?: string) {
  const result = useQuery(
    ['returnMaterial/detail', id],
    () => returnMaterialDetail(id),
    { enabled: !!id },
  );

  useServiceError(result.error);

  return result;
}
